import { useMemo, useState } from 'react'
import ClientDetailsModal from '../../modals/Cashier/ClientDetailsModal';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import EmptyData from '../../ui/EmptyData';
import { useSelector } from 'react-redux';
import QrCode from '../../modals/Cashier/QrCode';
import { selectCurrentAdditionalModalType, selectCurrentShowTypeOfModal, selectIsFetching, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import NewPINModal from '../../modals/Cashier/NewPINModal';
import { useMasterData } from '../../../hooks/api/useMasterData';
import ClientItem from '../../common/items/ClientItem';
import { useClientSocket } from '../../../hooks/socket/useClientSocket';
import { useOrderSocket } from '../../../hooks/socket/useOrderSocket';

interface ClientListProps {
    sortOptionClient: string;
}

export default function ClientList({ sortOptionClient }: ClientListProps) {
    
    const { clients: allClient, isErrorClients, isLoadingClients, errorMessageClients } = useMasterData()
    const isFetching = useSelector(selectIsFetching);
    const typeModal = useSelector(selectCurrentShowTypeOfModal);
    const [openQRCOdeModal, setOpenQRCodeModal] = useState<boolean>(false);
    const [newPIN, setNewPIN] = useState<number>(0)
    const [fetchPin, setFetchPin] = useState(false);
    const typeOfAddModal = useSelector(selectCurrentAdditionalModalType);
    const isCurrentlyLoading = isLoadingClients || isFetching;

    useClientSocket();
    
    const filteredClients = useMemo(() => {
        const now = new Date();
        return [...allClient]
            .filter((client) => {
                const scheduleTo = new Date(client.scheduleTo);
                switch (sortOptionClient) {
                    case 'Active':
                        return scheduleTo >= now;
                    case 'Inactive':
                        return scheduleTo < now;
                    default:
                        return true;
                }
            })
            .sort((a, b) => {
                const aIsActive = new Date(a.scheduleTo) >= now;
                const bIsActive = new Date(b.scheduleTo) >= now;
                if (aIsActive === bIsActive) return 0;
                return aIsActive ? -1 : 1;
            });
    }, [allClient, sortOptionClient]);

    return (
        <div className='overflow-hidden h-full rounded'>
            <div className='pr-0.5 h-full rounded overflow-y-auto'>
                {isCurrentlyLoading ? (
                    <Loading message="Loading clients..." />
                ) : isErrorClients ? (
                    <ErrorMessage message={errorMessageClients}/>
                ) : filteredClients.length === 0 ? (
                    <EmptyData message="No clients available." />
                ) : (
                <div className='grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 overflow-hidden '>
                    {filteredClients.map((client) => {
                        return (
                            <ClientItem
                                key={client.clientID}
                                client={client}
                            />
                        )
                    })}
                </div>
                )}
                { typeModal === 'viewClient' && (
                    <ClientDetailsModal setOpenQRCodeModal={setOpenQRCodeModal} />
                )}
                
                { typeOfAddModal === 'getNewPIN' && (
                    <NewPINModal
                        newPIN={newPIN}
                        setNewPIN={setNewPIN}
                        setFetchPin={setFetchPin}
                    />
                )}
                { openQRCOdeModal && (
                    <QrCode setOpenQRCodeModal={setOpenQRCodeModal} />
                )}
            </div>
        </div>
    )
}
